import { themeAtom } from "../../atoms";
import "./Checkbox.css";
import Checkmark from "./Checkmark";
import { useAtomValue } from "jotai";
import React, { useState } from "react";
import { twMerge } from "tailwind-merge";

interface Props {
  label?: string;
  checked?: boolean;
  name?: string;
  onChange?: () => void;
}

const Checkbox: React.FC<Props> = ({ label, name, checked, onChange, ...restProps }) => {
  const defaultChecked = checked ? checked : false;
  const [isChecked, setChecked] = useState(defaultChecked);
  const theme = useAtomValue(themeAtom);

  const handleCheckboxChange = () => {
    setChecked((prevState) => !prevState);
    onChange && onChange();
  };

  return (
    <div className="flex flex-row items-center gap-2">
      <input
        className={twMerge("w-[20px] rounded", theme.home.tailwind.panelBackground, isChecked && "checked")}
        type="checkbox"
        name={name}
        id={name}
        checked={isChecked}
        onChange={handleCheckboxChange}
        {...restProps}
      />
      <label className={twMerge("flex-1", theme.home.tailwind.textDefault)} htmlFor={name}>
        {label}
      </label>
      {isChecked && (
        <Checkmark className={twMerge("checkbox-checkmark", theme.sideBarComponent.iconAndText.tooltipText)} />
      )}
    </div>
  );
};

export default Checkbox;
